import supportModule from './support.module';

export default supportModule.config($stateProvider =>
    $stateProvider
        .state({
            parent: 'app',
            name: 'support',
            url: '/support',
            component: 'support',
            redirectTo: 'support_overview'
        })
        .state({
            parent: 'support',
            name: 'support_overview',
            url: '/overview',
            component: 'supportOverview',
            protected: true
        })
        .state({
            parent: 'support',
            name: 'support_createcase',
            url: '/createcase',
            component: 'supportCreateCase',
            protected: true
        })
        .state({
            parent: 'support',
            name: 'support_viewcase',
            url: '/case/:caseId',
            component: 'supportViewCase',
            protected: true,
            onEnter(
                $sessionStorage,
                $stateParams,
                accountProvider,
                asLoadingMask,
                liveChatService,
                supportViewCaseService
            ) {
                asLoadingMask.show();

                supportViewCaseService
                    .loadCase($stateParams.caseId)
                    .then(
                        currentCase => {
                            liveChatService.setCaseId(currentCase.id);
                        },
                        () => {}
                    )
                    .finally(() => {
                        asLoadingMask.hide();
                    });
            },
            onExit(liveChatService, supportViewCaseService) {
                supportViewCaseService.clearCase();

                liveChatService.setCaseId(undefined);
            }
        })
        .state({
            parent: 'support',
            name: 'support_otherwise',
            url: '/*path',
            redirectTo: 'support_overview'
        })
);



// WEBPACK FOOTER //
// ./modules/support/support.states.js